import { render, staticRenderFns } from "./addBusinessOpportunity.vue?vue&type=template&id=8c648d06&scoped=true"
import script from "./addBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./addBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./addBusinessOpportunity.vue?vue&type=style&index=0&id=8c648d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c648d06",
  null
  
)

export default component.exports